// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/black-friday/bg-25.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appbar-black-finde > .app-bar-generic {
  height: 6vh;
  padding-top: 0;
}

.appbar-black-finde > .app-bar-generic > .parrafo-new-appbar {
  margin-top: 0;
}

.appbar-black-finde
  > .app-bar-generic
  > .parrafo-new-appbar
  > .icono-color-new-appbar {
  color: #fff;
}

.bf-header,
.bf-header-finde {
  background-color: #1f1f1f;
  padding-top: 6rem;
  padding-bottom: 6rem;
  color: #fff;
  background: #e3e3e3 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  /* background-position: right 4vh; */
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 142%;
}

.bf-header-finde {
  padding-top: 2rem;
  padding-bottom: 0;
}

.bf-header-logo {
  padding-top: 7vh;
  padding-bottom: 4vh;
  position: fixed;
  width: 100vw;
}

.bf-flag {
  margin: 20px auto;
  width: 72vw;
}

.bf-logo {
  margin: 0 auto;
  margin-top: 0rem;
  width: 90vw;
}

.bf-discount {
  margin: 2em auto;
  width: 70vw;
}

.bf-text-hero-promo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2em;
  padding: 0 1.5em;
}

.bf-text-hero-promo-bold {
  text-transform: uppercase;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.bf-text-hero-promo-normal {
  font-family: "RedHatDisplay-Light", sans-serif;
  font-size: 2.5rem;
  text-align: center;
  color: #ffffff;
  font-weight: 300;
  text-transform: uppercase;
}

.bf-text-hero-promo-final {
  font-family: "Anton-Regular", sans-serif;
  font-size: 2.3rem;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  margin-top: 0.2em;
}

.bf-text-hero-promo-red {
  color: #db0b27;
}

.bf-button-header {
  /* padding-top: 2em; */
  padding-bottom: 2.5em;
}

.bf-button-header-text {
  font-size: 1.2rem;
  color: #ffffff;
  background-color: #db0b27;
  padding: 0.7rem 1.5rem;
  border-radius: 3px;
  margin-top: 0.5em;
  display: inline-block;
}

.bf-button-header-subtitle {
  /* margin-top: 1.5em; */
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2em;
  width: 100vw;
  margin: 0em auto 0 auto;
}

.bf-content {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  overflow-y: scroll;
  position: relative;
  top: 2vh;
  width: 100vw;
}

.bf-background {
  /* background: #e3e3e3 url("../assets/images/black-friday/bg-24.jpg") no-repeat; */
  background-size: contain;
  height: 100vh;
  overflow: scroll;
  position: fixed;
  z-index: -1;
}

.bf-title-text {
  font-size: 8.7vw;
  line-height: 1.4em;
  padding: 0 1em;
  color: #fff;
  /* margin-top: 4rem; */
}

.bf-title-marked {
  background-color: #fff;
  color: #da0d29;
}

.bf-subtitle-text {
  color: #ffffff;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 4.2vw;
  font-weight: 700;
  line-height: 1.5em;
  margin-top: 1.5rem;
  padding: 0 1.2em;
}

.bf-promo-info {
  /* margin-top: 5em; */
  padding: 5em 1.3em 0 1.3em;
  color: #333;
}

/* .bf-promo-info {
  height: auto;
  margin-bottom: 2vh;
  padding-bottom: 3vh;
  padding-right: 2vw;
  width: 88vw;
} */

.bf-promo-info-title {
  text-align: left;
  font-size: 24px;
  margin-bottom: 1.5em;
}

.bf-promo-info {
  line-height: 1.5em;
}

.bf-promo-info-title-first-line {
  display: block;
}

.bf-promo-info-title-underlined {
  /* text-decoration: underline; */
  color: #da0d29;
}

.bf-promo-info-title-underline-svg {
  position: absolute;
  /* top: 52%; */
  left: 2%;
  margin-top: -0.5em;
  width: calc(40% + 20px);
  /* height: calc(40% + 20px); */
  /* transform: translate(-50%, -50%); */
  overflow: visible;
}

.bf-promo-info-title-underline-svg path {
  stroke: #da0d29;
  stroke-width: 9;
  fill: none;
  opacity: 0;
  stroke-dasharray: 0 1500;
  transition: 0.3s;
  animation: headline-dash 1.5s linear 0s 1 forwards;
  /* animation: elementor-headline-dash forwards; */
  /* animation-duration: 0s; */
  /* animation-iteration-count: 1; */
  /* animation-duration: var(--animation-duration, 1.2s); */
  /* animation-iteration-count: 1; */
}

@keyframes headline-dash {
  0% {
    stroke-dasharray: 0 1500;
    opacity: 1;
  }
  to {
    stroke-dasharray: 1500 1500;
    opacity: 1;
  }
}

.bf-promo-info-text {
  padding: 0 1.4em;
}

.bf-info-description {
  font-size: 16px;
  line-height: 1.4em;
  text-align: left;
  color: #333;
  margin-bottom: 1.5em;
}

.bf-info-description h3 {
  font-size: 24px;
  line-height: 1.2em;
  margin-bottom: 1em;
}

.bf-info-description p {
  margin-bottom: 1.5em;
}

.bf-info-card {
  background-color: #1a1a1a;
  padding: 2em 1em;
  border-radius: 15px;
  color: #fff;
  margin-bottom: 4em;
}

.bf-info-card-dates {
  margin-top: 1em;
  margin-bottom: 1em;
}

.bf-info-card-year {
  font-size: 2em;
  letter-spacing: 4.4px;
}

.bf-discount-prox,
.bf-dates-info {
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 2vh;
  padding-top: 2vh;
  padding-bottom: 2vh;
  width: 90vw;
}

.bf-discount-img img {
  max-width: 70vw;
}

span.bf-dialog-icon img {
  position: absolute;
  display: inline-block;
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.bf-step-number {
  background-color: #db0b27;
  color: #fff;
  border-radius: 50%;
  font-family: "Muli-Black", sans-serif;
  font-size: 22px;
  font-weight: 900;
  padding: 0.4em 0.8em;
  display: block;
  left: 0;
  max-width: 1em;
  margin: 0em 0.4em 1em 0.4em;
  line-height: 1.8em;
}

.bf-info-card-title-header {
  text-align: left;
  font-size: 20px;
  line-height: 1.4em;
  padding: 0 0.4em;
  margin-bottom: 1.3em;
}

.bf-info-card-description {
  color: #ffffff;
  font-size: 16px;
  padding: 0 0.4em;
  line-height: 1.5em;
  font-family: "RedHatDisplay-Variable", sans-serif;
  font-weight: 600;
  text-align: left;
}

.bf-info-card-description-link {
  text-decoration: underline;
  color: #db0b27;
}

.bf-info-steps-dialog .bf-info-steps .bf-step-number {
  margin: 2.5vh 4vw 0 2vw;
}

@media screen and (min-width: 768px) {
  span.bf-icon img {
    width: 6vw;
  }

  .bf-discount-prox,
  .bf-dates-info {
    height: 9vh;
    padding-top: 1vh;
  }

  span.bf-dialog-icon img {
    width: 8vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/black-friday/black-friday.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,qEAA4E;EAC5E,oCAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kFAAkF;EAClF,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kDAAkD;EAClD,iDAAiD;EACjD,4BAA4B;EAC5B,kCAAkC;EAClC,yDAAyD;EACzD,kCAAkC;AACpC;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,OAAO;EACP,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".appbar-black-finde > .app-bar-generic {\n  height: 6vh;\n  padding-top: 0;\n}\n\n.appbar-black-finde > .app-bar-generic > .parrafo-new-appbar {\n  margin-top: 0;\n}\n\n.appbar-black-finde\n  > .app-bar-generic\n  > .parrafo-new-appbar\n  > .icono-color-new-appbar {\n  color: #fff;\n}\n\n.bf-header,\n.bf-header-finde {\n  background-color: #1f1f1f;\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n  color: #fff;\n  background: #e3e3e3 url(\"../assets/images/black-friday/bg-25.png\") no-repeat;\n  /* background-position: right 4vh; */\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 142%;\n}\n\n.bf-header-finde {\n  padding-top: 2rem;\n  padding-bottom: 0;\n}\n\n.bf-header-logo {\n  padding-top: 7vh;\n  padding-bottom: 4vh;\n  position: fixed;\n  width: 100vw;\n}\n\n.bf-flag {\n  margin: 20px auto;\n  width: 72vw;\n}\n\n.bf-logo {\n  margin: 0 auto;\n  margin-top: 0rem;\n  width: 90vw;\n}\n\n.bf-discount {\n  margin: 2em auto;\n  width: 70vw;\n}\n\n.bf-text-hero-promo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2em;\n  padding: 0 1.5em;\n}\n\n.bf-text-hero-promo-bold {\n  text-transform: uppercase;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 2.5rem;\n  font-weight: 700;\n  text-align: center;\n  color: #ffffff;\n}\n\n.bf-text-hero-promo-normal {\n  font-family: \"RedHatDisplay-Light\", sans-serif;\n  font-size: 2.5rem;\n  text-align: center;\n  color: #ffffff;\n  font-weight: 300;\n  text-transform: uppercase;\n}\n\n.bf-text-hero-promo-final {\n  font-family: \"Anton-Regular\", sans-serif;\n  font-size: 2.3rem;\n  font-weight: 700;\n  text-align: center;\n  color: #ffffff;\n  margin-top: 0.2em;\n}\n\n.bf-text-hero-promo-red {\n  color: #db0b27;\n}\n\n.bf-button-header {\n  /* padding-top: 2em; */\n  padding-bottom: 2.5em;\n}\n\n.bf-button-header-text {\n  font-size: 1.2rem;\n  color: #ffffff;\n  background-color: #db0b27;\n  padding: 0.7rem 1.5rem;\n  border-radius: 3px;\n  margin-top: 0.5em;\n  display: inline-block;\n}\n\n.bf-button-header-subtitle {\n  /* margin-top: 1.5em; */\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.2em;\n  width: 100vw;\n  margin: 0em auto 0 auto;\n}\n\n.bf-content {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  overflow-y: scroll;\n  position: relative;\n  top: 2vh;\n  width: 100vw;\n}\n\n.bf-background {\n  /* background: #e3e3e3 url(\"../assets/images/black-friday/bg-24.jpg\") no-repeat; */\n  background-size: contain;\n  height: 100vh;\n  overflow: scroll;\n  position: fixed;\n  z-index: -1;\n}\n\n.bf-title-text {\n  font-size: 8.7vw;\n  line-height: 1.4em;\n  padding: 0 1em;\n  color: #fff;\n  /* margin-top: 4rem; */\n}\n\n.bf-title-marked {\n  background-color: #fff;\n  color: #da0d29;\n}\n\n.bf-subtitle-text {\n  color: #ffffff;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 4.2vw;\n  font-weight: 700;\n  line-height: 1.5em;\n  margin-top: 1.5rem;\n  padding: 0 1.2em;\n}\n\n.bf-promo-info {\n  /* margin-top: 5em; */\n  padding: 5em 1.3em 0 1.3em;\n  color: #333;\n}\n\n/* .bf-promo-info {\n  height: auto;\n  margin-bottom: 2vh;\n  padding-bottom: 3vh;\n  padding-right: 2vw;\n  width: 88vw;\n} */\n\n.bf-promo-info-title {\n  text-align: left;\n  font-size: 24px;\n  margin-bottom: 1.5em;\n}\n\n.bf-promo-info {\n  line-height: 1.5em;\n}\n\n.bf-promo-info-title-first-line {\n  display: block;\n}\n\n.bf-promo-info-title-underlined {\n  /* text-decoration: underline; */\n  color: #da0d29;\n}\n\n.bf-promo-info-title-underline-svg {\n  position: absolute;\n  /* top: 52%; */\n  left: 2%;\n  margin-top: -0.5em;\n  width: calc(40% + 20px);\n  /* height: calc(40% + 20px); */\n  /* transform: translate(-50%, -50%); */\n  overflow: visible;\n}\n\n.bf-promo-info-title-underline-svg path {\n  stroke: #da0d29;\n  stroke-width: 9;\n  fill: none;\n  opacity: 0;\n  stroke-dasharray: 0 1500;\n  transition: 0.3s;\n  animation: headline-dash 1.5s linear 0s 1 forwards;\n  /* animation: elementor-headline-dash forwards; */\n  /* animation-duration: 0s; */\n  /* animation-iteration-count: 1; */\n  /* animation-duration: var(--animation-duration, 1.2s); */\n  /* animation-iteration-count: 1; */\n}\n\n@keyframes headline-dash {\n  0% {\n    stroke-dasharray: 0 1500;\n    opacity: 1;\n  }\n  to {\n    stroke-dasharray: 1500 1500;\n    opacity: 1;\n  }\n}\n\n.bf-promo-info-text {\n  padding: 0 1.4em;\n}\n\n.bf-info-description {\n  font-size: 16px;\n  line-height: 1.4em;\n  text-align: left;\n  color: #333;\n  margin-bottom: 1.5em;\n}\n\n.bf-info-description h3 {\n  font-size: 24px;\n  line-height: 1.2em;\n  margin-bottom: 1em;\n}\n\n.bf-info-description p {\n  margin-bottom: 1.5em;\n}\n\n.bf-info-card {\n  background-color: #1a1a1a;\n  padding: 2em 1em;\n  border-radius: 15px;\n  color: #fff;\n  margin-bottom: 4em;\n}\n\n.bf-info-card-dates {\n  margin-top: 1em;\n  margin-bottom: 1em;\n}\n\n.bf-info-card-year {\n  font-size: 2em;\n  letter-spacing: 4.4px;\n}\n\n.bf-discount-prox,\n.bf-dates-info {\n  border-radius: 4px;\n  margin: 0 auto;\n  margin-top: 2vh;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n  width: 90vw;\n}\n\n.bf-discount-img img {\n  max-width: 70vw;\n}\n\nspan.bf-dialog-icon img {\n  position: absolute;\n  display: inline-block;\n  max-height: 100%;\n  max-width: 100%;\n  width: auto;\n  height: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.bf-step-number {\n  background-color: #db0b27;\n  color: #fff;\n  border-radius: 50%;\n  font-family: \"Muli-Black\", sans-serif;\n  font-size: 22px;\n  font-weight: 900;\n  padding: 0.4em 0.8em;\n  display: block;\n  left: 0;\n  max-width: 1em;\n  margin: 0em 0.4em 1em 0.4em;\n  line-height: 1.8em;\n}\n\n.bf-info-card-title-header {\n  text-align: left;\n  font-size: 20px;\n  line-height: 1.4em;\n  padding: 0 0.4em;\n  margin-bottom: 1.3em;\n}\n\n.bf-info-card-description {\n  color: #ffffff;\n  font-size: 16px;\n  padding: 0 0.4em;\n  line-height: 1.5em;\n  font-family: \"RedHatDisplay-Variable\", sans-serif;\n  font-weight: 600;\n  text-align: left;\n}\n\n.bf-info-card-description-link {\n  text-decoration: underline;\n  color: #db0b27;\n}\n\n.bf-info-steps-dialog .bf-info-steps .bf-step-number {\n  margin: 2.5vh 4vw 0 2vw;\n}\n\n@media screen and (min-width: 768px) {\n  span.bf-icon img {\n    width: 6vw;\n  }\n\n  .bf-discount-prox,\n  .bf-dates-info {\n    height: 9vh;\n    padding-top: 1vh;\n  }\n\n  span.bf-dialog-icon img {\n    width: 8vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
